import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class DeuceFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return [FootballState.DeuceGood, FootballState.DeuceMissed].includes(
            fragment.associatedState
        );
    }

    getRawFragment(play, serializationContext, fragment) {
        const result =
            fragment.associatedState === FootballState.DeuceGood ? "G" : "M";

        // Kicker comes from the Kick fragment
        const kick = play.getFirstFragment(FootballState.Kick);
        const uniform = this.resolveUniform(
            serializationContext,
            kick.getPlayers()[0]
        );

        // Spot from the KickOff fragment's kickedTo
        const kickOff = play.getFirstFragment(FootballState.KickOff);
        const spot = this.resolveFormattedFieldPosition(
            serializationContext,
            kickOff.kickedTo
        );

        const team = this.resolveTeam(
            serializationContext,
            kick.getPlayers()[0]
        );

        return `DEUCE:${result},${team},${uniform},${spot}`;
    }
}
